import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import "./PaymentFailure.css";

export default function PaymentFailure() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("order_id");
  const code = searchParams.get("code");

  const [orderStatus, setOrderStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(null);

  useEffect(() => {
    if (!orderId) return;
    setLoading(true);
    setFetchError(null);
    const apiBase = process.env.API_URL || "https://api.goharesadaf.ir";
    fetch(`${apiBase}/api/orders/${orderId}/status`)
      .then((res) => {
        if (!res.ok) throw new Error("وضعیت سفارش قابل دریافت نیست");
        return res.json();
      })
      .then((data) => setOrderStatus(data))
      .catch((err) => setFetchError(err.message))
      .finally(() => setLoading(false));
  }, [orderId]);

  return (
    <div className="status-page">
      <div className="status-card failure">
        <div className="failure-image">
          <img src="/images/paymentFailure.png" alt="پرداخت ناموفق" />
        </div>

        <h1 className="status-title">پرداخت ناموفق</h1>
        <p className="status-message">
          متأسفیم — پرداخت شما به درگاه بانکی منتقل شد اما تأیید نشد. لطفاً دوباره تلاش کنید یا با پشتیبانی تماس بگیرید.
        </p>

        <div className="status-details">
          {orderId && <div><strong>شماره سفارش:</strong> <span>{orderId}</span></div>}
          {code && <div><strong>کد خطا:</strong> <span>{code}</span></div>}
          {loading && <div className="small-muted">در حال بررسی وضعیت سفارش...</div>}
          {fetchError && <div className="small-muted error">{fetchError}</div>}
          {orderStatus && (
            <div className="order-info">
              <div><strong>وضعیت سفارش:</strong> <span>{orderStatus.status}</span></div>
              {orderStatus.transaction_id && <div><strong>کد تراکنش:</strong> <span>{orderStatus.transaction_id}</span></div>}
            </div>
          )}
        </div>

        <div className="status-actions">
          <Link to="/cart" className="btn btn-outline">بازگشت به سبد خرید</Link>
          {orderId && <Link to={`/orders/${orderId}`} className="btn">مشاهده سفارش</Link>}
          {/* If you have a retry flow, swap href to the correct retry endpoint */}
          {orderId && <a href={`/orders/${orderId}`} className="btn btn-secondary" title="مشاهده سفارش و پرداخت مجدد">پرداخت مجدد</a>}
        </div>
      </div>
    </div>
  );
}
